import { FC } from "react";
import { Doc } from "sharedb/lib/client";

import { WorksheetType } from "../../../../shared/types/worksheet";
import { hasStudentTouchedAnyBlocks } from "../../../../shared/worksheets/progress-count";

import { ACCESS_ID_QUERY_PARAM } from "components/constants";
import { PageType } from "components/server-types";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { useAppSelector } from "store/index";
import { selectSortedUserFullSubmissionsByPageId } from "store/selectors";
import { isIndividualPage } from "utils/page-utils";
import { useQueryParamsManager } from "utils/routing";

interface SubmissionStatusBannerProps {
  page: PageType;
  doc?: Doc<WorksheetType>;
}

export const SubmissionStatusBanner: FC<SubmissionStatusBannerProps> = ({ page, doc }) => {
  const { getQueryParam } = useQueryParamsManager();
  const selectedAccessId = getQueryParam(ACCESS_ID_QUERY_PARAM);

  const userSubmissions = useAppSelector((s) =>
    selectSortedUserFullSubmissionsByPageId(s, page.id, selectedAccessId || undefined),
  );

  if (!selectedAccessId) {
    return null;
  }

  // Case 2: No submission
  if (userSubmissions.length === 0) {
    const userContext = isIndividualPage(page) ? "student" : "group";

    return (
      <Banner className="page-block-width" kind="warning">
        {t(`warning.no_${userContext}_submission`)}
      </Banner>
    );
  }

  // Case 1: Blank submission (student hasn't touched any blocks)
  if (doc && !hasStudentTouchedAnyBlocks(doc, selectedAccessId)) {
    return (
      <Banner className="page-block-width" kind="info">
        {t("warning.blank_submission")}
      </Banner>
    );
  }

  return null;
};
